<template>
	<div class="enterprisewebsite" v-title :data-title="msg" data="newsdetail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div v-if="userdata.token" class="flexcss">
					<div class="leftconbox whitebox" v-if="pagetypes == 1">
						<div class="newstitle">
							<h3 class="title">{{ title }}</h3>
							<p class="tac por">
								<span style="margin-right:50px">发布时间：{{ pagedata.publishTime }}</span>
								 <span style="margin-right:50px" v-show="pagedata.notion != ''">所属领域：
									{{ pagedata.notion }}</span>
								<!-- <span v-show="pagedata.good>0 && pagedata.star>0" :class="pagedata.good==1?'stargrade1 redstargrade oh':'stargrade1 greenstargrade oh'" style="line-height: 18px;" >影响程度：<i style="position: relative;top: 2px;" v-for="stard in pagedata.star"></i></span> -->
								<!-- <span v-show="pagedata.good==0 && pagedata.star>0" class="stargrade1 stargrade" style="line-height: 18px;"  >影响程度：<i class="starfull" style="position: relative;top: 2px;" v-for="stard in pagedata.star"></i></span> -->
							</p>
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
						<div class="newcon-recom"
							v-show="pageextend.policyDecode.length > 0 || pageextend.policySource.length > 0">
							<h3 class="title">{{ pageextend.policyDecode.length > 0 ? '政策解读' : "相关政策" }}</h3>
							<ul>
								<li :key="index" v-for="(item, index) in pageextend.policyDecode">
									<span class="onlyline fl">{{ item.title }}</span>
								</li>
								<li :key="index" v-for="(item, index) in pageextend.policySource">
									<span class="onlyline fl">{{ item.title }}</span>
								</li>
							</ul>
						</div>
					</div>

					<div class="leftconbox whitebox" v-if="pagetypes == 2">
						<div class="newstitle">
							<h3 class="title">{{ title }}</h3>
							<p class="tac por">
								<span style="margin-right:50px">发布时间：{{ pagedata.publishTime }}</span> <span
									style="margin-right:50px" v-show="pagedata.notion != ''">所属领域：
									{{ pagedata.notion }}</span>
							</p>
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
						<dl class="newsDe_key" v-if="pagetypes == 2" v-show="pagedata.keylist.length > 0">
							<dt class="fl">关键词：</dt>
							<dd class="fl"><span :key="index" v-for="(item, index) in pagedata.keylist"
									@click="tagrouter('/timeinforKey', 7, 'news', item.id, item.name)">{{ item.name }}</span>
							</dd>
						</dl>
					</div>

					<div class="leftconbox whitebox" style="width: 100%;" v-if="pagetypes == 3">
						<div class="newstitle">
							<h3 class="title">{{ title }}</h3>
							<p class="tac por">
								<span style="margin-right:50px"
									@click="routerlinkid('/enterprises', pagedata.stockCode)">相关公司： <em
										class="curp">{{ pagedata.enterpriseName }}</em></span>
								<span style="margin-right:50px">信息来源：<a :href="pagedata.sourceUrl"
										target="_blank">{{ pagedata.source }}</a></span>
								<span style="margin-right:50px">发布时间：{{ pagedata.publishTime }}</span>
							</p>
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
					</div>

					<div class="leftconbox whitebox" style="width: 100%;" v-if="pagetypes == 6">
						<div class="newstitle">
							<h3 class="title darkred">{{ title }}</h3>
							<!-- <p class="tac por">
						<span style="margin-right:50px" @click="routerlinkid('/enterprises',pagedata.stockCode)">相关公司： <em class="curp">{{pagedata.enterpriseName}}</em></span> 
						<span style="margin-right:50px">信息来源：<a :href="pagedata.sourceUrl" target="_blank">{{pagedata.source}}</a></span> 
						<span style="margin-right:50px">发布时间：{{pagedata.publishTime}}</span>
					</p> -->
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
					</div>

					<div class="leftconbox whitebox" style="width: 100%;" v-if="pagetypes == 5">
						<div class="newstitle">
							<h3 class="title">{{ title }}</h3>
							<p class="tac por">
								<span style="margin-right:50px">发布时间：{{ pagedata.publishTime }}</span> <span
									style="margin-right:50px" v-show="pagedata.notion && pagedata.notion != ''">所属领域：
									{{ pagedata.notion }}</span>
								<span style="margin-right:50px" v-show="pagedata.industryText != ''">所属行业：
									{{ pagedata.industryText }}&nbsp;&nbsp;{{ pagedata.industry2Text }}</span>
							</p>
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
						<dl class="newsDe_key" v-show="pagedata.categoryText != ''">
							<dt class="fl">关键词：</dt>
							<dd class="fl"><span class="basefont-nocur">{{ pagedata.categoryText }}</span></dd>
						</dl>
					</div>

					<div class="leftconbox whitebox" style="width: 100%;"
						v-if="pagetypes == 4 && userdata.groupType == 1">
						<div class="newstitle">
							<h3 class="title">{{ title }}</h3>
							<p class="tac por">
								<span style="margin-right:50px">对接人： {{ pagedata.contactPerson }}</span>
								<span style="margin-right:50px">所属领域：{{ pagedata.notion }}</span>
								<!-- <span style="margin-right:50px">发布时间： {{ pagedata.publishTime }} </span> -->
							</p>
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
					</div>
					<!-- 选址项目的试用账户提示 旧版 纯文字 暂时弃用 -->
					<div class="whitebox trial-box" v-if="userdata.groupType != 1 && pagetypes == 4">
						<freeUserTips :type="2" :bgtype="14" v-if="userdata.isFree || userdata.groupType == 0">
						</freeUserTips>
						<!-- <h3>成为正式用户即可解锁更多信息</h3>
				<h4>联系电话：400 008 0586、0755-8257 1568</h4> -->
					</div>

					<div class="rightrecommend" v-if="pagetypes == 1 || pagetypes == 2" v-show="hotpolicy.length > 0">
						<div class="whitebox hotinchain">
							<h4 class="title">热门产业政策</h4>
							<ul>
								<li :key="i" v-for="(item, i) in hotpolicy" v-show="i < 4">
									<span class="onlyline db"
										@click="routerlinkid('/news', item.id, 1)">{{ item.title }}</span>
									<!-- <p class="stargrade fr"><i class="starfull" v-for="star in item.grade"></i><i class="stargray" v-for="star in (5-item.grade)"></i></p> -->
								</li>
							</ul>
						</div>
						<div class="whitebox hotinchain" v-if="pagetypes == 3" v-show="relatednews.length > 0">
							<h4 class="title">相关资讯动态</h4>
							<ul>
								<li :key="i" v-for="(item, i) in relatednews" v-show="i < 4">
									<span class="onlyline db"
										@click="routerlinkid('/news', item.id, pagetypes)">{{ item.title }}</span>
									<!-- <p class="stargrade fr"><i class="starfull" v-for="star in item.grade"></i><i class="stargray" v-for="star in (5-item.grade)"></i></p> -->
								</li>
							</ul>
						</div>
					</div>
					<!-- 新版产业政策 -->
					<div class="leftconbox whitebox" style="width: 100%;" v-if="pagetypes == 7">
						<div class="newstitle">
							<h3 class="title">{{ title }}</h3>
							<p class="tac por">
								<span style="margin-right:50px">发布时间：{{ pagedata.time }}</span> <span
									style="margin-right:50px" v-show="pagedata.notion && pagedata.notion != ''">所属领域：
									{{ pagedata.notion }}</span>
								<span style="margin-right:50px" v-show="pagedata.industryText != ''">政策类型：
									{{ pagedata.type }}&nbsp;&nbsp;{{ pagedata.industry2Text }}</span>
							</p>
						</div>
						<div class="newscontent" v-html="pagedata.content"></div>
						<div class="newsDe_key">
							<el-tag size="medium" class="mr-1" v-show="pagedata.tag != ''">{{ pagedata.tag }}</el-tag>
							<el-tag size="medium" class="mr-1" v-show="pagedata.level != ''">{{ pagedata.level
								}}</el-tag>
						</div>
					</div>

				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div>
				</div>
			</div>

		</div>

		<!-- <footerbar v-if="userdata.userType>1"></footerbar> -->
	</div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'newsdetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			msg: "newsdetail",
			pagetypes: 1,//1为政策 2为招商情报(ocnnews)3为企业资讯（enterpriseNews)4为选址项目5为产业动态监测，6为用户优惠活动消息 7为2024.4.29新版的政策
			typeaarr: ['政策', '招商情报', '企业资讯', '选址项目', '产业资讯动态', '最新消息', '最新政策'],
			curindex: 7,
			newsid: 1,
			hotlist: [],
			hotpolicy: [],
			pageextend: { policyDecode: [], policySource: [] },
			pagedata: { star: 0, content: "", notion: '', publishTime: "", keylist: [] },
			title: "", relatednews: [],
			userdata: {},
		}
	},
	components: {
		freeUserTips
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
		this.newsid = this.$route.query.id * 1;
		// this.userdata.groupType=0; 
		this.pagetypes = this.$route.query.type ? this.$route.query.type : 1;
		// this.gethottopic()
	},
	mounted() {

		if (this.userdata.edition < 1) {
			var that = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				that.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		if (this.userdata.groupType == 0 && this.pagetypes == 4) {
			return;
		} else {
			this.bus.$emit('loading', true);
		}
		console.log(this.pagetypes, this.typeaarr[this.pagetypes - 1]);
		if (this.pagetypes == 1 || this.pagetypes == 2) {
			this.getPolicyOcnnews(this.pagetypes);
			this.getRelatedPolicy();
		} else if (this.pagetypes == 3) {
			this.getEnterpriseNewsdetail();
			this.curindex = 50;
		} else if (this.pagetypes == 4 && this.userdata.groupType != 0) {
			this.getSiteProjectDetail();
		} else if (this.pagetypes == 5) {
			this.getParkNewDetail();
		} else if (this.pagetypes == 6) {
			this.bus.$emit('loading', false);
			this.getUserMessage();
		} else if (this.pagetypes == 7) {
			this.getPolicyListNewVesion();
		}

	},
	methods: {
		getPolicyListNewVesion() {
			this.$axios.get(this.$api.common.policy.detail() + '?id=' + this.newsid, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then((res) => {
				console.log(res);
				if (res.data.success) {
					console.log('新版政策详情', res.data);
					this.pagedata = res.data.data;
					document.title = res.data.data.title;
					this.title = res.data.data.title;
					this.bus.$emit('loading', false);
				}
			})
		},
		getUserMessage() {
			var that = this;
			this.$axios.get(this.$api.cyl.userMessage.detail() + '?id=' + this.newsid, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log('动态消息展示详情', res.data);
					that.pagedata = res.data.data;
					document.title = res.data.data.title;
					that.title = res.data.data.title;
					that.bus.$emit('loading', false);
				}
			})
		},
		getPolicyOcnnews(type) {
			var that = this, ajaxurl = '';
			if (type == 1) {
				ajaxurl = this.$api.cyl.news.detail() + '?id=' + this.newsid;
			} else if (type == 2) {
				ajaxurl = this.$api.cyl.OCNNews.detail() + '?id=' + this.newsid;
			}
			console.log(ajaxurl)
			this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 稍微有点数据
				console.log(res.data);
				that.pagedata = res.data.data;
				// that.pageextend=res.data.extend;
				if (res.data.extend != null) {
					that.pageextend.policyDecode = res.data.extend.policyDecode == undefined ? [] : res.data.extend.policyDecode;
					that.pageextend.policySource = res.data.extend.policySource == undefined ? [] : res.data.extend.policySource;
					// console.log(that.pageextend.policySource,that.pageextend.policyDecode);
					// console.log(res.data.extend.policySource,res.data.extend.policyDecode);
				};
				that.pagedata.content = that.pagedata.content.replace(new RegExp('<p><br/></p>', 'g'), '');
				if (type == 2) {
					that.pagedata.keylist = that.taglistfun(that.pagedata.keywordsText, that.pagedata.keywords);
				}
				// console.log();
				that.hotlist = res.data.list;
				document.title = res.data.data.title;
				that.title = res.data.data.title;
				that.bus.$emit('loading', false);
				// that.chainnodelist=; 
			})
		},
		getRelatedPolicy() {
			var that = this;
			var ajaxurl = this.$api.cyl.news.list() + "?type=2&bigClass=30008";
			this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log("政策链",res);
				if (res.data.code < 1) {
					that.hotpolicy = res.data.list;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		getrelatednews(enterpriseid) {
			var ajaxurl = this.$api.cyl.enterprisenews.list() + '?date=month&stockCode=' + enterpriseid + '&page=1';
			var that = this;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(ajaxurl)
				console.log('获取相关企业资讯列表', res.data)
				if (res.data.success) {
					that.relatednews = res.data.list.filter(list => {
						return list.id != that.newsid;
					});
					that.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		getEnterpriseNewsdetail() {
			var that = this;
			console.log(this.$api.cyl.enterprisenews.detail() + '?id=' + this.newsid)
			this.$axios.get(this.$api.cyl.enterprisenews.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 资讯详情页数据
				// console.log(res.data );
				that.pagedata = res.data.data;
				console.log(res.data.data);
				document.title = res.data.data.title;
				that.title = res.data.data.title;
				that.getrelatednews(res.data.data.stockCode);
				// that.bus.$emit('loading',false);
				// that.chainnodelist=; 
			})
		},
		getSiteProjectDetail() {
			var that = this;
			console.log(this.$api.cyl.projectnews.detail() + '?id=' + this.newsid)
			this.$axios.get(this.$api.cyl.projectnews.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 资讯详情页数据
				console.log('getSiteProjectDetail', res.data);
				that.pagedata = res.data.data;
				// console.log(res.data.data) ;
				document.title = res.data.data.title;
				that.title = res.data.data.title;
				// that.getrelatednews(res.data.data.stockCode);
				that.bus.$emit('loading', false);
				// that.chainnodelist=; 
			})
		},
		getParkNewDetail() {
			var that = this;
			console.log(this.$api.park.news.detail() + '?id=' + this.newsid);
			this.$axios.get(this.$api.park.news.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 资讯详情页数据
				console.log('getParkNewDetail', res.data);
				that.pagedata = res.data.data;
				// console.log(res.data.data) ;
				document.title = res.data.data.title;
				that.title = res.data.data.title;
				// that.getrelatednews(res.data.data.stockCode);
				that.bus.$emit('loading', false);
				// that.chainnodelist=; 
			})
		},
		getPolicydetail() {
			var that = this;
			this.$axios.get(this.$api.cyl.news.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 稍微有点数据
				console.log(res.data);
				that.pagedata = res.data.data;
				// that.pageextend=res.data.extend;
				if (res.data.extend != null) {
					that.pageextend.policyDecode = res.data.extend.policyDecode == undefined ? [] : res.data.extend.policyDecode;
					that.pageextend.policySource = res.data.extend.policySource == undefined ? [] : res.data.extend.policySource;
					// console.log(that.pageextend.policySource,that.pageextend.policyDecode);
					// console.log(res.data.extend.policySource,res.data.extend.policyDecode);
				};
				that.pagedata.content = that.pagedata.content.replace(new RegExp('<p><br/></p>', 'g'), '');
				// console.log();
				that.hotlist = res.data.list;
				document.title = res.data.data.title;
				that.title = res.data.data.title;
				that.bus.$emit('loading', false);
				// that.chainnodelist=; 
			})
		},
		getocnNewsdetail() {
			var that = this;
			this.$axios.get(this.$api.cyl.OCNNews.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 稍微有点数据
				console.log(res.data);
				that.pagedata = res.data.data;
				// that.pageextend=res.data.extend;
				if (res.data.extend != null) {
					that.pageextend.policyDecode = res.data.extend.policyDecode == undefined ? [] : res.data.extend.policyDecode;
					that.pageextend.policySource = res.data.extend.policySource == undefined ? [] : res.data.extend.policySource;
					// console.log(that.pageextend.policySource,that.pageextend.policyDecode);
					// console.log(res.data.extend.policySource,res.data.extend.policyDecode);
				};
				that.pagedata.content = that.pagedata.content.replace(new RegExp('<p><br/></p>', 'g'), '');
				that.pagedata.keylist = that.taglistfun(that.pagedata.keywordsText, that.pagedata.keywords);
				// console.log();
				that.hotlist = res.data.list;
				document.title = res.data.data.title;
				that.title = res.data.data.title;
				that.bus.$emit('loading', false);
				// that.chainnodelist=; 
			})
		},

	}
}



</script>

<style scoped="scoped">
.leftconbox {
	min-height: 840px;
}
</style>
